<template>
  <v-combobox
      v-model="selectedKeyword"
      :items="keywords"
      variant="solo-filled"
      :loading="isLoading"
      class="inputSuggestion"
      style="max-width: 180px;font-size: 12px"
      label=""
      placeholder="請輸入關鍵字"
      menu-icon=""
      density="compact"
      prepend-inner-icon="mdi-magnify"
      color="success"
      clearable
      dense
  ></v-combobox>
</template>
<script>
export default {
    name: 'inputSuggestion',
    components: {},
    props: {
    },
    data() {
        return {
          keywords: [],
          selectedKeyword: this.paramKeyword,
          isLoading: false,
        };
    },
    beforeMount() {
      this.isLoading = true;
      axios
          .get('/api/getTagKeywordSuggestion')
          .then((response) => {
            this.keywords = response.data;
          })
          .catch((error) => {
            console.error('Error fetching keywords:', error);
          })
          .finally(() => {
            this.isLoading = false;
          });
        const urlParams = new URLSearchParams(window.location.search);
        this.selectedKeyword = urlParams.get('keyword') || '';
    },
    mounted() {

    },
    computed: {},
    methods: {
      syncKeyword() {
        // 明確選擇隱藏的 <input> 元素
        const inputElement = this.$el.querySelector('.v-select__slot input');
        if (inputElement) {
          this.selectedKeyword = inputElement.value;
        }
        return this.selectedKeyword;
      },
    },
    watch: {
    },
};

</script>
<style lang="scss">
.inputSuggestion {
  .v-select__slot {
    input, textarea {
      border: none; /* 移除外框 */

      &:focus, &:hover {
        border: none;
      }
    }
  }
}
</style>
